import { useEffect, useRef } from 'react';
export var HEIGHT_ELEMENT_CLASS_NAME = 'ai-height-div';
/**
 * whenever we update modal size - we want to update editor size to accommodate for it
 * This hook listens for modal size changes, and updates editor content area height accordingly
 */
function useUpdateEditorHeight(_ref) {
  var modalElement = _ref.modalElement,
    editorViewElement = _ref.editorViewElement;
  var heightDivRef = useRef(null);

  // listen to changes to modal size
  useEffect(function () {
    if (!modalElement) {
      return;
    }
    var resizeObserver = new ResizeObserver(function (entries) {
      if (!heightDivRef.current || !modalElement) {
        return;
      }
      var modalEntry = entries.find(function (e) {
        return e.target === modalElement;
      });
      // entry should always exist for modaRef as we're observing on it, this check makes ts happy
      if (!modalEntry) {
        return;
      }
      var modalBottom = modalEntry.target.offsetTop + modalEntry.contentRect.height;
      var editorBottom = editorViewElement.offsetTop + editorViewElement.offsetHeight;

      // The height of the extra div should be expanded to reach
      // the bottom of the modal -- so that no modal content is outside
      // the editor
      var heightToSet = Math.max(modalBottom - editorBottom, 0);
      heightDivRef.current.style.height = "".concat(heightToSet, "px");
    });
    resizeObserver.observe(modalElement);
    return function () {
      resizeObserver.disconnect();
    };
  }, [modalElement, editorViewElement]);

  // Create an element for adjusting height of editor when modal is visible
  useEffect(function () {
    if (heightDivRef.current) {
      // In future react will fire useEffect twice in dev mode
      // this early exit avoids issues with this
      return;
    }
    var newDiv = document.createElement('div');
    newDiv.className = HEIGHT_ELEMENT_CLASS_NAME;
    newDiv.style.height = "0px";
    editorViewElement.parentNode.appendChild(newDiv);
    heightDivRef.current = newDiv;
    return function () {
      var _editorViewElement$pa;
      (_editorViewElement$pa = editorViewElement.parentNode) === null || _editorViewElement$pa === void 0 || _editorViewElement$pa.removeChild(newDiv);
    };
  }, [editorViewElement]);
}
export default useUpdateEditorHeight;